import StockQuote from './StockQuote'
// Uncomment the below to migrate to stateful component
// import StockQuoteContainer from './StockQuoteContainer'

export { StockQuote }
export default StockQuote
// Uncomment the below to migrate to stateful component
// export { StockQuoteContainer }
// export default { StockQuoteContainer }
